export default {"src":"/_next/static/media/white-instagram-icon.b0feedee.svg","height":47,"width":48};